import {Box, Button} from "@mui/material";
import React from "react";

export type PersistenceButtonsProps = {
  isDirty: boolean,
  onSave: () => void,
  onDiscard: () => void
}

export const PersistenceButtons: React.FC<PersistenceButtonsProps> = ({ isDirty, onSave, onDiscard }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-end',
      }}
    >
      <Button
        variant='outlined'
        onClick={onDiscard}
        disabled={!isDirty}
        sx={{marginRight: 1}}
      >
        Annuler
      </Button>
      <Button
        variant='contained'
        onClick={onSave}
        disabled={!isDirty}
      >
        Enregistrer
      </Button>
    </Box>
  )
}